import { render, staticRenderFns } from "./api.vue?vue&type=template&id=3f671c18&"
import script from "./api.vue?vue&type=script&lang=js&"
export * from "./api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports